import { Status } from './models';

export const isCheckoutSessionPaid = (status?: Status) => status === Status.PAID;
export const isCheckoutSessionUnpaid = (status?: Status) => status === Status.UNPAID;
export const isCheckoutSessionExpired = (status?: Status) => status === Status.EXPIRED;
export const checkoutSessionMaxPayAttemptsReached = (status?: Status) => status === Status.MAX_PAY_ATTEMPTS;
export const isCheckoutSessionCancelled = (status?: Status) => status === Status.CANCELLED;
